'use client';

import React, { forwardRef, useCallback, useRef, useState } from 'react';
import clsx from 'clsx';
import { Element } from '../element';
import { Image } from '../image';
import * as styles from './avatar.styles';
import placeholder from './placeholder.png';
import { setRef, useOnViewport } from '../../../hooks';

/** @type {typeof import(".").Avatar} */
const Avatar = forwardRef(({ className, children, src = placeholder.src, size = 100, level = '', style, ...props }, ref) => {
  const [source, setSource] = useState();
  const [hasError, setHasError] = useState(false);
  const innerRef = useRef();

  const onViewportCallback = useCallback(() => {
    setSource(src);
  }, [src]);

  useOnViewport(innerRef, onViewportCallback);

  let as = Image;
  let otherProps = {
    width: size,
    height: size,
  };

  if (children) {
    as = 'div';
    otherProps = {};
  }
  return (
    <span
      className={clsx(styles.root, className, styles.variants[level.toLowerCase()])}
      style={{ ...style, ...(size && { '--avatar-size': typeof size === 'string' ? size : `${size}px` }) }}
      ref={setRef(innerRef, ref)}
    >
      <span className={clsx(styles.avatar, { [styles.variants.text]: children })}>
        <Element
          src={source}
          as={as}
          loading="lazy"
          alt="avatar"
          {...otherProps}
          onError={() => {
            setHasError(true);
          }}
          {...props}
          {...(hasError && { src: placeholder.src })}
          {...(as === Image && {
            sizes: [Number(size) || 100],
          })}
        >
          {as !== Image ? children : undefined}
        </Element>
      </span>
    </span>
  );
});

if (process.env.NODE_ENV !== 'production') {
  Avatar.displayName = 'Avatar';
}

export default Avatar;
